import { render, staticRenderFns } from "./inflationMaintenance.vue?vue&type=template&id=247468d4&scoped=true"
import script from "./inflationMaintenance.vue?vue&type=script&lang=js"
export * from "./inflationMaintenance.vue?vue&type=script&lang=js"
import style0 from "./inflationMaintenance.vue?vue&type=style&index=0&id=247468d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247468d4",
  null
  
)

export default component.exports